import './index.css'
import head1 from '../Images/head1.jpeg'
import head2 from '../Images/head2.jpg'
import head3 from '../Images/head3.jpg'
import head4 from '../Images/head4.jpg'

import React, { useEffect, useState } from 'react';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import Slider from '../Slider/Slider'
import ProductList from '../ProductList/ProductList'
import Footer from '../Footer/Footer'
import header from '../Images/header.jpeg'
import axios from 'axios'

const Home = () => {
    // Slider State
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [head1, head2, head3, head4]; // Use imported images here

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex(
            (prevIndex) => (prevIndex - 1 + images.length) % images.length
        );
    };


    const [userCount, setUserCount] = useState(0);

    const [products, setProducts] = useState(0);

    const [referral, setReferral] = useState(0);
    
    const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     // Fetch all users from the backend API
    //     fetch('https://api.lbnhyderabad.com/signup/get')
    //         .then((response) => response.json())
    //         .then((data) => {
    //             // Set the number of users (length of the array)
    //             setUserCount(data.length);
    //             setLoading(false); // Set loading to false once data is fetched   
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching users:', error);
    //             setLoading(false);
    //         });
    // }, []);
    // useEffect(() => {
    //     // Fetch all users from the backend API
    //     fetch('https://api.lbnhyderabad.com/refferal/api/referralstore')
    //         .then((response) => response.json())
    //         .then((data) => {
    //             // Set the number of users (length of the array)
    //             setReferral(data.length);
    //             setLoading(false); // Set loading to false once data is fetched   
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching users:', error);
    //             setLoading(false);
    //         });
    // }, []);

    // useEffect(() => {
    //     // Fetch all users from the backend API
    //     fetch('https://api.lbnhyderabad.com/product/show-all-data')
    //         .then((response) => response.json())
    //         .then((data) => {
    //             // Set the number of users (length of the array)
    //             setProducts(data.length);
    //             setLoading(false); // Set loading to false once data is fetched   
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching users:', error);
    //             setLoading(false);
    //         });
    // }, []);


    const fetchUsers = async () => {
        try {
            const response = await fetch('https://api.lbnhyderabad.com/signup/get');
            const data = await response.json();
            setUserCount(data.length);
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    // Function to fetch referrals
    const fetchReferral = async () => {
        try {
            const response = await fetch('https://api.lbnhyderabad.com/refferal/api/referralstore');
            const data = await response.json();
            setReferral(data.length);
        } catch (error) {
            console.error('Error fetching referrals:', error);
        } finally {
            setLoading(false);
        }
    };

    // Function to fetch products
    const fetchProducts = async () => {
        try {
            const response = await fetch('https://api.lbnhyderabad.com/product/show-all-data');
            const data = await response.json();
            setProducts(data.length);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    const [sum, setSum] = useState(null);
    const [error, setError] = useState(null);

    // useEffect(() => {
    //     // Fetch the sum from the backend API when the component mounts
    //     fetch('https://api.lbnhyderabad.com/product/sum-additionalinfo')
    //       .then((response) => response.json())
    //       .then((data) => {
    //         // Set the sum in state
    //         setSum(data.total);
    //         setLoading(false); // Stop loading once data is fetched
    //       })
    //       .catch((error) => {
    //         // Handle any error during the fetch
    //         console.error('Error fetching sum:', error);
    //         setError('Failed to load data');
    //         setLoading(false);
    //       });
    //   }, []);


    const fetchSum = async () => {
        try {
            const response = await fetch('https://api.lbnhyderabad.com/product/sum-additionalinfo');
            const data = await response.json();
            setSum(data.total); // Set the fetched sum into state
        } catch (error) {
            console.error('Error fetching sum:', error);
            setError('Failed to load data');
        } finally {
            setLoading(false); // Stop loading after the request is complete
        }
    };


    //     fetch('https://api.lbnhyderabad.com/product/sum-additionalinfo')
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log('Total sum of additionalInfo:', data.total);
    //     // You can display this data in the frontend as needed
    //   })
    //   .catch(error => console.error('Error fetching data:', error));
    
    useEffect(() => {
        fetchSum();
        fetchUsers();
        fetchReferral();
        fetchProducts();
    }, []);

    const cardStyle = {
        width: '200px',
        padding: '15px',
        border: '1px solid #ddd',
        borderRadius: '10px',
        backgroundColor:'#4d51bf',
      
        boxShadow: '0 4px 6px rgba(36, 80, 239, 0.53)',
        
        textAlign: 'center',
        margin: '10px', // Add space between the cards
    };

    const titleStyle = {
        fontSize: '1.2rem',
        marginBottom: '10px',
        color: 'white',
    };

    const textStyle = {
        fontSize: '1rem',
        color: 'white',
        fontWeight: 'bold',
    };

    const containerStyle = {
        display: 'flex',
        justifyContent: 'space-around', // Space between the cards
        flexWrap: 'wrap', // Allow the cards to wrap on smaller screens
    };
    const [images1, setImages1] = useState([]);
    const [currentIndex1, setCurrentIndex1] = useState(0);


      // Fetch images on mount
  useEffect(() => {
    axios.get('https://api.lbnhyderabad.com/admin-dashboard/api/images') // Replace with your API URL
      .then((res) => {
        const data = res.data[0]; // assuming one record
        const imageArray = [data.main_add_1, data.main_add_2, data.main_add_3].filter(Boolean);
        setImages1(imageArray);
      })
      .catch((err) => {
        console.error('Error fetching images:', err);
      });
  }, []);

  // Auto-scroll every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex1((prevIndex) => (prevIndex + 1) % images1.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images1]);

  const prevSlide1 = () => {
    setCurrentIndex1((prevIndex) => (prevIndex === 0 ? images1.length - 1 : prevIndex - 1));
  };

  const nextSlide2 = () => {
    setCurrentIndex1((prevIndex) => (prevIndex + 1) % images1.length);
  };

//     return (

//         <div className='response-container'>
//             <main className="main-content">
//                 <div className="text-section">
//                     <h1>Welcome LBN Multiple District 320</h1>
//                     <ul style={{ listStyleType: 'none', marginTop: 15, paddingLeft: 0, marginLeft: 0 }}>
//                         <li>To Promote Business Opportunities for LIONS</li>
//                         <li>To Encourage young entrepreneurs to JOIN LIONS and to SERVE the Needy.</li>
//                         <li>To Promote Fellowship through Business Networking</li>
//                         <li>To Enhance the Image of Lions Organisation with YOUTH.</li>
//                     </ul>
//                     <p className='leading-relaxed'>
//                         Multiple District 320 was formed in the year 2016-17 and was inaugurated by our International President Naresh Ji Agarwal on 7th July 2016 at Marriott Hotel Hyderabad.

//                         The Multiple District is the seventh Multiple District in India consisting of districts of Telangana State, and part of Karnataka. We are having currently 22000+ members with 650+ clubs.</p>

//                 </div>

// {/* 
//                 <div className="slider-section">
//                     <div className="slider-container1">
//                         <FaArrowAltCircleLeft className="slider-arrow left" onClick={prevSlide} />
//                         <img src={images[currentIndex]} alt="Lions Business Network Logo" className="slider-images" />
//                         <FaArrowAltCircleRight className="slider-arrow right" onClick={nextSlide} />
//                     </div>
//                 </div> */}
// <div className="slider-section">
//       <div className="slider-container1">
//         <FaArrowAltCircleLeft className="slider-arrow left" onClick={prevSlide1} />
//         {images1.length > 0 && (
//           <img
//             src={images1[currentIndex1]}
//             alt="Lions Business Network"
//             className="slider-images"
//           />
//         )}
//         <FaArrowAltCircleRight className="slider-arrow right" onClick={nextSlide2} />
//       </div>
//     </div>

//             </main>

//             <div style={containerStyle}>
//                 <div style={cardStyle}>
//                     <h5 style={titleStyle}>LBN MEMBERS</h5>
//                     <p style={textStyle}>{loading ? 'Loading...' : `${userCount} `}</p>
//                 </div>
//                 <div style={cardStyle}>
//                     <h5 style={titleStyle}>REFERRALS</h5>
//                     <p style={textStyle}>{loading ? 'Loading...' : `${referral} `}</p>
//                 </div>
//                 <div style={cardStyle}>
//                     <h5 style={titleStyle}>PRODUCTS</h5>
//                     <p style={textStyle}>{loading ? 'Loading...' : `${products} `}</p>
//                 </div>
//                 <div style={cardStyle}>
//                     <h5 style={titleStyle}>BUSINESS</h5>
//                     <p style={textStyle}>{loading ? 'Loading...' : `${sum} `}</p>
//                 </div>
             
//             </div>



//             <Slider />
//             <ProductList />


//         </div>
//     );

// return (
//   <div style={{ width: "100%", overflowX: "hidden" }}>
//     {/* HERO SECTION */}
//     <main
//       style={{
//         width: "100%",
//         height: "100vh",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* BACKGROUND IMAGE */}
//       <div className="slider-section">
//         <div
//           className="slider-container1"
//           style={{
//             width: "100%",
//             height: "100vh",
//             position: "relative",
//           }}
//         >
//           <FaArrowAltCircleLeft
//             className="slider-arrow left"
//             onClick={prevSlide1}
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "20px",
//               transform: "translateY(-50%)",
//               zIndex: 5,
//               color: "#fff",
//               fontSize: "50px",
//               background: "rgba(255,255,255,0.2)",
//               borderRadius: "50%",
//               padding: "8px",
//               cursor: "pointer",
//             }}
//           />

//           {images1.length > 0 && (
//             <img
//               src={images1[currentIndex1]}
//               alt="Lions Business Network"
//               className="slider-images"
//               style={{
//                 width: "100%",
//                 height: "100vh",
//                 objectFit: "cover",
//               }}
//             />
//           )}

//           <FaArrowAltCircleRight
//             className="slider-arrow right"
//             onClick={nextSlide2}
//             style={{
//               position: "absolute",
//               top: "50%",
//               right: "20px",
//               transform: "translateY(-50%)",
//               zIndex: 5,
//               color: "#fff",
//               fontSize: "50px",
//               background: "rgba(255,255,255,0.2)",
//               borderRadius: "50%",
//               padding: "8px",
//               cursor: "pointer",
//             }}
//           />
//         </div>
//       </div>

//       {/* DARK OVERLAY */}
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           background: "rgba(0,0,0,0.55)",
//           zIndex: 1,
//         }}
//       ></div>

//       {/* TEXT SECTION */}
//       <div
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "10%",
//           transform: "translateY(-50%)",
//           zIndex: 2,
//           width: "55%",
//           color: "#fff",
//         }}
//       >
//         <h3
//           style={{
//             fontSize: "30px",
//             fontWeight: "800",
//             // lineHeight: "55px",
//             marginBottom: "30px",
//           }}
//         >
//           Welcome{" "}
//           <span style={{ color: "#f7c75d" }}>
//             LBN Multiple
//           </span>
//           <br />
//           District 320
//         </h3>

//         <ul
//           style={{
//             listStyle: "none",
//             padding: 0,
//             marginTop: "25px",
//           }}
//         >
//           <li
//             style={{
//               fontSize: "18px",
//               marginBottom: "20px",
//             //   lineHeight: "30px",
//             }}
//           >
//             ✦ To Promote Business Opportunities for LIONS
//           </li>

//           <li
//             style={{
//               fontSize: "18px",
//               marginBottom: "20px",
//               lineHeight: "38px",
//             }}
//           >
//             ✦ To Encourage Young Entrepreneurs to JOIN
//             LIONS and SERVE the Needy
//           </li>

//           <li
//             style={{
//               fontSize: "18px",
//               marginBottom: "20px",
//               lineHeight: "38px",
//             }}
//           >
//             ✦ To Promote Fellowship through Business
//             Networking
//           </li>

//           <li
//             style={{
//               fontSize: "18px",
//               marginBottom: "20px",
//               lineHeight: "38px",
//             }}
//           >
//             ✦ To Enhance the Image of Lions Organisation
//             with YOUTH
//           </li>
//         </ul>

//         <p
//           style={{
//             fontSize: "20px",
//             // lineHeight: "42px",
//             // marginTop: "40px",
//             color: "#f1f1f1",
//           }}
//         >
//           Multiple District 320 was formed in the year
//           2016-17 and was inaugurated by our International
//           President Naresh Ji Agarwal on 7th July 2016 at
//           Marriott Hotel Hyderabad.
//           <br />
//           <br />
//           The Multiple District is the seventh Multiple
//           District in India consisting of districts of
//           Telangana State and part of Karnataka. We currently
//           have 22000+ members with 650+ clubs.
//         </p>
//       </div>
//     </main>

//     {/* STATS CARDS */}
//     <div
//       style={{
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         gap: "35px",
//         marginTop: "70px",
//         position: "relative",
//         zIndex: 10,
//         flexWrap: "wrap",
//         paddingBottom: "70px",
//         background: "#f4f6fb",
//       }}
//     >
//       {/* CARD 1 */}
//       <div
//         style={{
//           width: "300px",
//           height: "210px",
//           borderRadius: "20px",
//           background:
//             "linear-gradient(135deg,#2b77ff,#1b4fd3)",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           color: "#fff",
//           boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
//         }}
//       >
//         <div style={{ fontSize: "42px" }}>👥</div>

//         <p
//           style={{
//             fontSize: "42px",
//             fontWeight: "bold",
//             margin: "10px 0",
//           }}
//         >
//           {loading ? "Loading..." : `${userCount}`}
//         </p>

//         <h5
//           style={{
//             fontSize: "20px",
//             letterSpacing: "1px",
//             fontWeight: "500",
//           }}
//         >
//           LBN MEMBERS
//         </h5>
//       </div>

//       {/* CARD 2 */}
//       <div
//         style={{
//           width: "300px",
//           height: "210px",
//           borderRadius: "20px",
//           background:
//             "linear-gradient(135deg,#c02cff,#8b19d6)",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           color: "#fff",
//           boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
//         }}
//       >
//         <div style={{ fontSize: "42px" }}>🔗</div>

//         <p
//           style={{
//             fontSize: "42px",
//             fontWeight: "bold",
//             margin: "10px 0",
//           }}
//         >
//           {loading ? "Loading..." : `${referral}`}
//         </p>

//         <h5
//           style={{
//             fontSize: "20px",
//             letterSpacing: "1px",
//             fontWeight: "500",
//           }}
//         >
//           REFERRALS
//         </h5>
//       </div>

//       {/* CARD 3 */}
//       <div
//         style={{
//           width: "300px",
//           height: "210px",
//           borderRadius: "20px",
//           background:
//             "linear-gradient(135deg,#00c853,#009624)",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           color: "#fff",
//           boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
//         }}
//       >
//         <div style={{ fontSize: "42px" }}>📦</div>

//         <p
//           style={{
//             fontSize: "42px",
//             fontWeight: "bold",
//             margin: "10px 0",
//           }}
//         >
//           {loading ? "Loading..." : `${products}`}
//         </p>

//         <h5
//           style={{
//             fontSize: "20px",
//             letterSpacing: "1px",
//             fontWeight: "500",
//           }}
//         >
//           PRODUCTS
//         </h5>
//       </div>

//       {/* CARD 4 */}
//       <div
//         style={{
//           width: "300px",
//           height: "210px",
//           borderRadius: "20px",
//           background:
//             "linear-gradient(135deg,#ff6d00,#e65100)",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           color: "#fff",
//           boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
//         }}
//       >
//         <div style={{ fontSize: "42px" }}>📈</div>

//         <p
//           style={{
//             fontSize: "42px",
//             fontWeight: "bold",
//             margin: "10px 0",
//           }}
//         >
//           {loading ? "Loading..." : `${sum}`}
//         </p>

//         <h5
//           style={{
//             fontSize: "20px",
//             letterSpacing: "1px",
//             fontWeight: "500",
//           }}
//         >
//           BUSINESS
//         </h5>
//       </div>
//     </div>

//     <Slider />

//     <ProductList />
//   </div>
// );


return (
  <div style={{ width: "100%", overflowX: "hidden" }}>
    {/* HERO SECTION */}
    <main
      style={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* BACKGROUND IMAGE */}
      <div className="slider-section">
        <div
          className="slider-container1"
          style={{
            width: "100%",
            height: "100vh",
            position: "relative",
          }}
        >
          <FaArrowAltCircleLeft
            className="slider-arrow left"
            onClick={prevSlide1}
            style={{
              position: "absolute",
              top: "50%",
              left: window.innerWidth < 600 ? "10px" : "20px",
              transform: "translateY(-50%)",
              zIndex: 5,
              color: "#fff",
              fontSize: window.innerWidth < 600 ? "32px" : "50px",
              background: "rgba(255,255,255,0.2)",
              borderRadius: "50%",
              padding: "8px",
              cursor: "pointer",
            }}
          />

          {images1.length > 0 && (
            <img
              src={images1[currentIndex1]}
              alt="Lions Business Network"
              className="slider-images"
              style={{
                width: "100%",
                height: "100vh",
                objectFit: "cover",
              }}
            />
          )}

          <FaArrowAltCircleRight
            className="slider-arrow right"
            onClick={nextSlide2}
            style={{
              position: "absolute",
              top: "50%",
              right: window.innerWidth < 600 ? "10px" : "20px",
              transform: "translateY(-50%)",
              zIndex: 5,
              color: "#fff",
              fontSize: window.innerWidth < 600 ? "32px" : "50px",
              background: "rgba(255,255,255,0.2)",
              borderRadius: "50%",
              padding: "8px",
              cursor: "pointer",
            }}
          />
        </div>
      </div>

      {/* DARK OVERLAY */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.55)",
          zIndex: 1,
        }}
      ></div>

      {/* TEXT SECTION */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: window.innerWidth < 768 ? "5%" : "10%",
          transform: "translateY(-50%)",
          zIndex: 2,
          width:
            window.innerWidth < 600
              ? "90%"
              : window.innerWidth < 1024
              ? "75%"
              : "55%",
          color: "#fff",
        }}
      >
        <h3
          style={{
            fontSize:
              window.innerWidth < 480
                ? "28px"
                : window.innerWidth < 768
                ? "38px"
                : window.innerWidth < 1024
                ? "50px"
                : "65px",
            fontWeight: "800",
            lineHeight:
              window.innerWidth < 480
                ? "38px"
                : window.innerWidth < 768
                ? "48px"
                : "75px",
            marginBottom: "25px",
          }}
        >
          Welcome{" "}
          <span style={{ color: "#f7c75d" }}>
            LBN Multiple
          </span>
          <br />
          District 320
        </h3>

        <ul
          style={{
            listStyle: "none",
            padding: 0,
            marginTop: "20px",
          }}
        >
          {[
            "To Promote Business Opportunities for LIONS",
            "To Encourage Young Entrepreneurs to JOIN LIONS and SERVE the Needy",
            "To Promote Fellowship through Business Networking",
            "To Enhance the Image of Lions Organisation with YOUTH",
          ].map((item, index) => (
            <li
              key={index}
              style={{
                fontSize:
                  window.innerWidth < 480
                    ? "14px"
                    : window.innerWidth < 768
                    ? "16px"
                    : "20px",
                marginBottom: "15px",
                lineHeight:
                  window.innerWidth < 480
                    ? "24px"
                    : "34px",
              }}
            >
              ✦ {item}
            </li>
          ))}
        </ul>

        <p
          style={{
            fontSize:
              window.innerWidth < 480
                ? "13px"
                : window.innerWidth < 768
                ? "15px"
                : "20px",
            lineHeight:
              window.innerWidth < 480
                ? "24px"
                : window.innerWidth < 768
                ? "28px"
                : "38px",
            color: "#f1f1f1",
            marginTop: "20px",
          }}
        >
          Multiple District 320 was formed in the year
          2016-17 and was inaugurated by our International
          President Naresh Ji Agarwal on 7th July 2016 at
          Marriott Hotel Hyderabad.
          <br />
          <br />
          The Multiple District is the seventh Multiple
          District in India consisting of districts of
          Telangana State and part of Karnataka. We currently
          have 22000+ members with 650+ clubs.
        </p>
      </div>
    </main>

    {/* STATS CARDS */}
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: window.innerWidth < 600 ? "20px" : "35px",
        marginTop: window.innerWidth < 768 ? "40px" : "70px",
        position: "relative",
        zIndex: 10,
        flexWrap: "wrap",
        padding: window.innerWidth < 600 ? "20px" : "40px",
        background: "#f4f6fb",
      }}
    >
      {[
        {
          icon: "👥",
          value: userCount,
          title: "LBN MEMBERS",
          bg: "linear-gradient(135deg,#2b77ff,#1b4fd3)",
        },
        {
          icon: "🔗",
          value: referral,
          title: "REFERRALS",
          bg: "linear-gradient(135deg,#c02cff,#8b19d6)",
        },
        {
          icon: "📦",
          value: products,
          title: "PRODUCTS",
          bg: "linear-gradient(135deg,#00c853,#009624)",
        },
        {
          icon: "📈",
          value: sum,
          title: "BUSINESS",
          bg: "linear-gradient(135deg,#ff6d00,#e65100)",
        },
      ].map((card, index) => (
        <div
          key={index}
          style={{
            width:
              window.innerWidth < 480
                ? "100%"
                : window.innerWidth < 768
                ? "90%"
                : window.innerWidth < 1024
                ? "45%"
                : "300px",
            maxWidth: "320px",
            height: window.innerWidth < 480 ? "180px" : "210px",
            borderRadius: "20px",
            background: card.bg,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              fontSize:
                window.innerWidth < 480 ? "32px" : "42px",
            }}
          >
            {card.icon}
          </div>

          <p
            style={{
              fontSize:
                window.innerWidth < 480 ? "32px" : "42px",
              fontWeight: "bold",
              margin: "10px 0",
            }}
          >
            {loading ? "Loading..." : `${card.value}`}
          </p>

          <h5
            style={{
              fontSize:
                window.innerWidth < 480 ? "16px" : "20px",
              letterSpacing: "1px",
              fontWeight: "500",
            }}
          >
            {card.title}
          </h5>
        </div>
      ))}
    </div>

    <Slider />

    <ProductList />
  </div>
);




};



export default Home